import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

import { Router } from "@angular/router";

@Component({
  selector: 'app-dash-header',
  templateUrl: './dash-header.component.html',
  styleUrls: ['./dash-header.component.css']
})
export class DashHeaderComponent implements OnInit {

 

  constructor(private  authService:  AuthService ,public  router:  Router) { }

  ngOnInit() {
    let login = this.authService.isLoggedIn;
    console.log("Login " +login);

    if (!login) {
      this.router.navigate(['dashboard']);
    }
  }
  

}
